import React, { Suspense } from "react";

var lazy = function lazy(callback) {
  var Component = React.lazy(callback);
  return function () {
    return /*#__PURE__*/React.createElement(Suspense, {
      fallback: /*#__PURE__*/React.createElement("div", null, "Loading ...")
    }, /*#__PURE__*/React.createElement(Component, null));
  };
};

export default lazy;